
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import Jquery from 'jquery';
    import { ControladorDeInicio } from './controlador';
    import resultado from './control-bultos-finalizar-resultado.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            resultado,

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public ControladorPrincipal: ControladorDeInicio;

        @Prop()
        public Controlador: ControladorDeInicio;

        public get Bultos() { return this.Controlador.Bultos; }
        public get Estado() { return this.Controlador.Vista.Estado; }

        public Controlado: boolean = false;
        public Resultado: boolean = false;
        public Diferencia: string = '';
        public Buscando: boolean = false;
        public Peso: number = null;
        @Watch( 'Peso' )
        onBusqueda()
        {
            if ( this.Peso > 0 )
            {

            }
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        public async Cancelar()
        {
            this.Controlador.Cancelar();
            this.ControladorPrincipal.Vista.Modo = 'menu';
        }

        public async Controlar()
        {
            if ( this.Resultado )
                return this.Volver();

            if ( this.Peso <= 0 )
                return;

            let e = await this.Controlador.Controlar( this.Peso );
            console.log( e );
            this.Resultado = e.resultado;

            this.Diferencia = e.diferencia.toFixed( 2 );
            this.Controlado = true;
            this.Peso = null;
            Jquery( '#input-peso' ).focus();
        }

        public async Volver()
        {
            this.Controlador.Sonar(true);
            this.Controlador.Iniciar();
            this.Controlador.Vista.Modo = 'inicio';
        }
    }
